<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Inventory Vehicle</h1>
    <app-navpath class="hidden md:block"></app-navpath>
  </div>

  <div class="content-container">
    <div class="flex w-full flex-col gap-3 px-4 py-4 text-sm md:flex-row md:items-center md:px-8">
      <label class="flex w-full flex-col gap-2 md:flex-row md:items-center">
        <p class="w-full font-bold md:w-36">
          File Location
        </p>
        <input
          type="file"
          class="w-full min-w-0 flex-grow md:max-w-xl"
          (change)="onFileChange($event)"
          accept=".xlsx, .xls"
        />
      </label>
      <button class="shorter-btn misc-btn w-full md:w-auto" (click)="ShowData()">
        <fa-icon [icon]="faEye" class="mr-1" />Show List
      </button>
      <button
        *ngIf="showUpload && InventoryVehicles.length > 0"
        class="shorter-btn misc-btn w-full md:w-auto"
        (click)="AddVehicles()"
      >
        <fa-icon [icon]="faUpload" class="mr-1" />Upload
      </button>
    </div>

    <div class="w-full">
      <app-data-table
        *ngIf="showUpload && InventoryVehicles.length > 0"
        class="inventory-vehicle-table block w-full"
        [tableHeaders]="tableHeaders"
        [tableEntries]="filterEntries(InventoryVehicles)"
        [pagination]="false"
      />
    </div>
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">
      Vehicle Details Summary
    </h2>
    <div class="flex flex-col gap-y-4 px-4 py-4 text-sm font-bold md:w-1/2 md:px-8">
      <p>
        Total of
        {{ response?.Total && showUpload ? response?.Total : 0 }}
        unit vehicle loaded.
      </p>
      <div *ngIf="showUpload" class="flex flex-col gap-y-4">
        <p *ngFor="let item of response?.PurchaseInvNumbers">
          {{ item.Name }}: {{ item.SubTotal }} units
        </p>
        <p *ngFor="let item of response?.PurchaseInvNumbersDetails">
          {{ item.Name }}: {{ item.SubTotal }} units
        </p>
        <p
          *ngFor="let item of response?.FileValidationError"
          class="text-red-600"
        >
          {{ item }}
        </p>
      </div>
    </div>
  </div>
</section>
